<script setup lang="js">
import { MODAL_CONFIRM } from '@/const';

import { useModalStore } from '@/stores/modal.store';
import ModalTemplate from '@/components/newModals/ModalTemplate.vue';

const props = defineProps({
  title: { type: String, required: true },
  btnCancel: { type: String, default: 'Отмена' },
  btnConfirm: { type: String, default: 'Сохранить' },
});

const modalStore = useModalStore();
</script>

<template>
  <ModalTemplate class="add-layer-modal">
    <template #title>
      {{ props.title }}
    </template>

    <template #footer="{ close }">
      <button class="btn-default btn-cancel" @click="close()">
        {{ props.btnCancel }}
      </button>
      <button class="btn-default btn-primary" @click="modalStore.modalEmit(MODAL_CONFIRM)">
        {{ props.btnConfirm }}
      </button>
    </template>
  </ModalTemplate>
</template>
